import { Phone, KeyRound } from "lucide-react";
import { Link } from "react-router-dom";
import { useSite } from "@/context/SiteContext";
import { UI } from "@/i18n";
import { fileUrl } from "@/lib/api";

export default function Footer() {
  const { content, t, lang, toggleLang } = useSite();
  return (
    <footer className="relative">
      <div className="h-1.5 bg-[linear-gradient(90deg,#2E9BE8_0%,#F97316_50%,#E63946_100%)]" />
      <div className="bg-brand-ink border-t border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid md:grid-cols-3 gap-10">
          <div>
            <img src={fileUrl(content?.logo_url)} alt="CT Upholstery" className="h-16 w-auto rounded-lg border border-white/10 mb-4" />
            <p className="text-sm text-white/60 max-w-xs">{t(content?.footer_note)}</p>
          </div>
          <div className="text-sm space-y-3">
            <p className="font-mono2 text-xs uppercase tracking-widest text-brand-orange mb-4">Contact</p>
            <a href={`tel:${content?.phone}`} className="flex items-center gap-2 font-mono2 font-semibold hover:text-brand-orange transition-colors">
              <Phone size={14} /> {content?.phone}
            </a>
            <p className="text-white/60">{t(content?.hours)}</p>
            <p className="text-white/60">{t(content?.service_area)}</p>
          </div>
          <div className="text-sm space-y-3 md:text-right">
            <button onClick={toggleLang} data-testid="footer-lang-toggle" className="font-mono2 text-xs border border-white/20 rounded-full px-4 py-2 hover:border-brand-orange hover:text-brand-orange transition-colors">
              {lang === "en" ? "Español" : "English"}
            </button>
            <p className="text-white/40 text-xs">
              © {new Date().getFullYear()} {content?.site_name}. {t(UI.footer.rights)}
            </p>
            <Link to="/admin/login" data-testid="footer-admin-link" className="inline-flex items-center gap-1.5 text-xs text-white/30 hover:text-brand-blue transition-colors">
              <KeyRound size={12} /> {t(UI.footer.adminAccess)}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
